import { styled } from 'styled-components';

export const CardButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.sizing.small};
`;
CardButtons.displayName = 'CardButtons';

export const CardHeightWrapper = styled.div`
  > div {
    height: auto;
  }

  margin: ${({ $margin }) => $margin || '0'};
`;
CardHeightWrapper.displayName = 'CardHeightWrapper';
